import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * True once the labor-ticket part-count subscription has delivered a count for the
 * current clock-in. Reset to false on clock-in change until the subscription responds.
 *
 * Used to decide whether the count passed to the embedded labor ticket form is
 * authoritative: while false, the form should fall back to its own part-count query
 * instead of a placeholder 0.
 */
export const getLaborTicketPartsLoaded = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketPartsLoaded;
  }
);
